<app-support-request-list *ngIf="supportRequests" [allSupportRequests]="supportRequests"></app-support-request-list>
